import { NgModule } from '@angular/core';
import { BuProgressComponent } from './bu-progress/bu-progress.component';

@NgModule({
  imports: [],
  declarations: [BuProgressComponent],
  exports: [BuProgressComponent]
})
export class BuProgressModule { }
